import React, { useContext } from 'react';
import cn from 'classnames';
import { Button } from '../../../../../button/esm';
import { Text } from '../../../../../typography/esm';
import { ConfirmationContext } from '../../../context.js';
import { Header } from '../../header/component.js';
import '../../../utils.js';

var styles = {"component":"confirmation__component_1wxoh","typographyTheme":"confirmation__typographyTheme_1wxoh","typographyThemeMobile":"confirmation__typographyThemeMobile_1wxoh","left":"confirmation__left_1wxoh","center":"confirmation__center_1wxoh","button":"confirmation__button_1wxoh"};
require('./index.css');

var FatalError = function (_a) {
    var _b;
    var mobile = _a.mobile;
    var _c = useContext(ConfirmationContext), alignContent = _c.alignContent, texts = _c.texts, onFatalErrorOkButtonClick = _c.onFatalErrorOkButtonClick, breakpoint = _c.breakpoint, client = _c.client;
    return (React.createElement("div", { className: cn(styles.component, styles[alignContent]) },
        React.createElement(Header, { mobile: mobile }, texts.fatalErrorTitle),
        React.createElement(Text, { view: 'primary-medium', color: 'primary', className: cn((_b = {},
                _b[styles.typographyTheme] = !mobile,
                _b[styles.typographyThemeMobile] = mobile,
                _b)) }, texts.fatalErrorDescription),
        React.createElement(Button, { size: mobile ? 'xs' : 's', view: 'secondary', onClick: onFatalErrorOkButtonClick, className: styles.button, breakpoint: breakpoint, client: client }, texts.fatalErrorButton)));
};

export { FatalError };
